import SelectExtractionRights from "@components/form/admin_approvals/create_forward_draw/SelectExtractionRights";
import { useForwardDrawContext } from "@context/ForwardDrawContext";
import { useAllExtractionRights } from "@hooks/query/zenith/useAllExtractionRights";
import { extractionRightTypes } from "@services/extractionRight";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import StepActions from "@components/zenith/ui/StepActions";

type WorkflowCreateForwardDrawStep1Props = {
  onSubmit: () => void;
};

const WorkflowCreateForwardDrawStep1: FunctionComponent<
  WorkflowCreateForwardDrawStep1Props
> = ({ onSubmit }) => {
  const navigate = useNavigate();

  const { details, setDetails } = useForwardDrawContext();

  const { data: extractionRights = [] } = useAllExtractionRights({
    params: {
      typeIds: [extractionRightTypes.WA, extractionRightTypes.WSA],
    },
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col grow" onSubmit={handleSubmit}>
      <div className="flex grow gap-4">
        <SelectExtractionRights
          embedded
          extractionRights={extractionRights}
          selectedExtractionRights={details.extractionRights}
          setSelectedExtractionRights={(extractionRights: any[]) => {
            setDetails({
              ...details,
              extractionRights,
            });
          }}
        />
      </div>
      <StepActions
        onCancel={() => navigate("/zenith/workflows")}
        nextDisabled={!details.extractionRights?.length}
      />
    </form>
  );
};

export default WorkflowCreateForwardDrawStep1;
